import React, {useEffect, useState} from "react";
import axios from "axios";
import {Template} from "../../../components/template/template.jsx";
import Player from "../../../components/vms-player/vms-player.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
let intervalReconnectCameras;

const Mosaic = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [selectedCameras, setSelectedCameras] = useState([]);
    const [camerasToRetry, setCamerasToRetry] = useState([])

    useEffect(() => {
        const videoCamerasId = localStorage.getItem("video-cameras");
        if (videoCamerasId) {
            getCameras(JSON.parse(videoCamerasId))
                .then(camerasToAudit => {
                    axios.post(`${API_KEEPER}/livestream/audit`, {cameras: JSON.stringify(camerasToAudit)})
                        .then(r => {})
                        .catch(error => {
                            console.error(error);
                        });
                });
        }
    }, []);

    const getCameras = async (videoCameras) => {
        if (videoCameras.length > 9) {
            videoCameras.length = 9
        }

        const newSelectedCameras = [];

        for (const camera of videoCameras) {
            try {
                const vmsCameraId = typeof camera.id === "number"
                    ? camera.id
                    : parseInt(camera.id.match(/(\d+)$/)?.[0] ?? "", 10) || null;

                const {data: dataVms} = await axios.get(`${API_KEEPER}/vms/camera/permission/${camera.vmsId}?cameraId=${vmsCameraId}`)
                    .then((data) => {
                        return data;
                    })
                    .catch(error => {throw error});

                newSelectedCameras.push(dataVms);
            } catch (error) {
                console.error(error)
            }
        }


        if (selectedCameras.length === 0) {
            setSelectedCameras([...newSelectedCameras]);

            return [...newSelectedCameras];
        } else {
            if (newSelectedCameras.length > 0) {
                setSelectedCameras((prevItems) =>
                    prevItems.map((item) => {
                            const cameraFind = newSelectedCameras.find(c => item.id === c.id && item.vmsId === c.vmsId);
                            if (cameraFind) return cameraFind

                            return item;
                        }
                    )
                );
            }
        }

    }

    useEffect(() => {
        if (camerasToRetry.length > 0) {
            if (intervalReconnectCameras) clearInterval(intervalReconnectCameras);

            intervalReconnectCameras = setInterval(() => {
                getCameras(camerasToRetry).then(() => {})
            }, 5000)
        }

        return () => {
            clearInterval(intervalReconnectCameras)
        }
    }, [camerasToRetry]);

    const cameraJsx = (camera, index) => {
        if (!camera) camera = {}

        const singleCamera = selectedCameras.length === 1;
        return (
            <div key={index} className={singleCamera ? "single-camera" : "camera"}>
                <div className="camera-header">
                    <div className="name">{camera?.name} - {camera?.vmsName ? camera.vmsName : camera.vmsUrl ?new URL(camera.vmsUrl)?.host : ""}</div>
                </div>
                <div className="player">
                    {
                        (camera.url || camera.streamUrl) &&
                        <Player camera={camera}/>
                    }
                    {
                        (!camera.url && !camera.streamUrl) &&
                        <>Erro ao conectar a câmera.</>
                    }
                </div>
            </div>
        )
    }

    const columns = Math.ceil(Math.sqrt(selectedCameras.length)) || 1;

    return (
        <>
            <Template isLoading={isLoading}>
                <Template.Header>
                    <Template.Title>
                        Mosaico
                    </Template.Title>
                </Template.Header>
                <Template.Body className={"!p-0"}>
                {
                    selectedCameras.length > 1 &&
                    <div className={"mosaic-total columns-" + columns}>
                        {selectedCameras.map((c, index) => cameraJsx(c, index))}
                    </div>
                }

                {
                    selectedCameras.length === 1 &&
                    selectedCameras.map((c, index) => cameraJsx(c, index))
                }
                </Template.Body>
            </Template>
        </>
    );
}

export default Mosaic;